import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LayoutMain from '../LayoutMain/LayoutMain';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import WaterMark from "../DashboardMain/WaterMark";

export default function Arai() {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "ARAI"
      }
    })
  }, []);

  return (
    <>
      <LayoutMain>
        <div className="row">
          <WaterMark />
          <div className="col-md-3" style={{}}>
            <Link to="/arai/ais">
              <div className="dashboard_card ev_card_title">
                <img src="../../../assets/img/DriveAnalysis.svg" />
                <span>AIS 038</span>
              </div>
            </Link>
          </div>
        </div>
      </LayoutMain>
    </>
  );
}
